const state = {

    back: null,

    isLoading: false,

    showFooter: true,

}

const getters = {

    back: state => state.back,

    isLoading: state => state.isLoading,

    showFooter: state => state.showFooter

}

const actions = {

  hideFooter({ commit })
  {
    commit('showFooter', false)
  },

  showFooter({ commit })
  {
    commit('showFooter', true)
  }

}

const mutations = {

    setBack (state, route = null) {
      state.back = route
    },

    setLoading (state, status = true) {
      state.isLoading = status
    },

    showFooter(state, status = true) {
      state.showFooter = status
    }

}

const ui = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export default ui